import type { DrinkCategory } from "../types";

// このファイルは data/drink_menu_heroscafe_2.csv から自動生成されます
// 手動で編集しないでください
// 編集は data/drink_menu_heroscafe_2.csv を変更後に `npm run gen:drinks` を実行してください

export const DRINK_MENU: DrinkCategory[] = [
  {
    "id": "C01",
    "name": "Spirits",
    "subCategories": [
      {
        "id": "S01",
        "name": "GIN",
        "items": [
          {
            "id": "M001",
            "name": "ゴードン",
            "price": 700
          },
          {
            "id": "M002",
            "name": "ボンベイサファイア",
            "price": 750
          },
          {
            "id": "M003",
            "name": "タンカレー",
            "price": 750
          },
          {
            "id": "M004",
            "name": "タンカレー No.10",
            "price": 850
          },
          {
            "id": "M005",
            "name": "シュタイン・ヘーガー",
            "price": 750
          }
        ]
      },
      {
        "id": "S02",
        "name": "GIN BASE",
        "items": [
          {
            "id": "M006",
            "name": "ジントニック",
            "price": 750
          },
          {
            "id": "M007",
            "name": "ジンバック",
            "price": 750
          },
          {
            "id": "M008",
            "name": "ジンライム",
            "price": 750
          },
          {
            "id": "M009",
            "name": "ジン・フィズ",
            "price": 750
          },
          {
            "id": "M010",
            "name": "ギムレット",
            "price": 850
          },
          {
            "id": "M011",
            "name": "ホワイトレディー",
            "price": 850
          }
        ]
      },
      {
        "id": "S03",
        "name": "TEQUILA",
        "items": [
          {
            "id": "M012",
            "name": "クエルボゴールド",
            "price": 700
          }
        ]
      },
      {
        "id": "S04",
        "name": "TEQUILA BASE",
        "items": [
          {
            "id": "M013",
            "name": "テコニック",
            "price": 750
          },
          {
            "id": "M014",
            "name": "メキシコーラ",
            "price": 750
          },
          {
            "id": "M015",
            "name": "テキーラサンライズ",
            "price": 800
          },
          {
            "id": "M016",
            "name": "マルガリータ",
            "price": 850
          },
          {
            "id": "M017",
            "name": "エル・ディアブロ",
            "price": 800
          }
        ]
      },
      {
        "id": "S05",
        "name": "RED BULL",
        "items": [
          {
            "id": "M018",
            "name": "テキーラ・ウォッカetc...",
            "price": 900
          }
        ]
      },
      {
        "id": "S06",
        "name": "RUM",
        "items": [
          {
            "id": "M019",
            "name": "バカルディホワイト",
            "price": 700
          },
          {
            "id": "M020",
            "name": "キャプテンモルガン プライベートストック",
            "price": 800
          },
          {
            "id": "M021",
            "name": "ロンサカパ センテナリオ",
            "price": 850
          }
        ]
      },
      {
        "id": "S07",
        "name": "RUM BASE",
        "items": [
          {
            "id": "M022",
            "name": "ラムコーク",
            "price": 750
          },
          {
            "id": "M023",
            "name": "ボストニアン",
            "price": 750
          },
          {
            "id": "M024",
            "name": "ダイキリ",
            "price": 850
          },
          {
            "id": "M025",
            "name": "X・Y・Z",
            "price": 850
          },
          {
            "id": "M026",
            "name": "ラムトニック",
            "price": 750
          },
          {
            "id": "M027",
            "name": "ソル・クバーノ",
            "price": 750
          }
        ]
      },
      {
        "id": "S08",
        "name": "VODKA",
        "items": [
          {
            "id": "M028",
            "name": "ズブロッカ",
            "price": 700
          },
          {
            "id": "M029",
            "name": "スミノフ",
            "price": 750
          }
        ]
      },
      {
        "id": "S09",
        "name": "VODKA BASE",
        "items": [
          {
            "id": "M030",
            "name": "ウォッカトニック",
            "price": 750
          },
          {
            "id": "M031",
            "name": "モスコミュール",
            "price": 750
          },
          {
            "id": "M032",
            "name": "スクリュードライバー",
            "price": 750
          },
          {
            "id": "M033",
            "name": "セックスオンザビーチ",
            "price": 800
          },
          {
            "id": "M034",
            "name": "ブルドッグ",
            "price": 750
          },
          {
            "id": "M035",
            "name": "ブラッディ・メアリー",
            "price": 750
          },
          {
            "id": "M036",
            "name": "カミカゼ",
            "price": 850
          }
        ]
      }
    ]
  },
  {
    "id": "C02",
    "name": "Liqueur",
    "subCategories": [
      {
        "id": "S10",
        "name": "CASIS BASE",
        "items": [
          {
            "id": "M037",
            "name": "カシスオレンジ",
            "price": 700
          },
          {
            "id": "M038",
            "name": "カシスグレープフルーツ",
            "price": 700
          },
          {
            "id": "M039",
            "name": "カシスウーロン",
            "price": 700
          },
          {
            "id": "M040",
            "name": "カシスソーダ",
            "price": 700
          }
        ]
      },
      {
        "id": "S11",
        "name": "DITA BASE",
        "items": [
          {
            "id": "M041",
            "name": "ディタグレープフルーツ",
            "price": 750
          },
          {
            "id": "M042",
            "name": "ディタトニック",
            "price": 750
          }
        ]
      },
      {
        "id": "S12",
        "name": "CAMPARI BASE",
        "items": [
          {
            "id": "M043",
            "name": "カンパリオレンジ",
            "price": 700
          },
          {
            "id": "M044",
            "name": "カンパリグレープフルーツ",
            "price": 700
          },
          {
            "id": "M045",
            "name": "カンパリソーダ",
            "price": 700
          },
          {
            "id": "M046",
            "name": "スプモーニ",
            "price": 750
          }
        ]
      },
      {
        "id": "S13",
        "name": "OTHER",
        "items": [
          {
            "id": "M047",
            "name": "ピーチツリー",
            "price": 700
          },
          {
            "id": "M048",
            "name": "抹茶",
            "price": 700
          },
          {
            "id": "M049",
            "name": "ベイリーズ",
            "price": 700
          },
          {
            "id": "M050",
            "name": "カンパリ",
            "price": 700
          },
          {
            "id": "M051",
            "name": "マリブ",
            "price": 700
          },
          {
            "id": "M052",
            "name": "アマレット",
            "price": 700
          },
          {
            "id": "M053",
            "name": "SOCO",
            "price": 700
          },
          {
            "id": "M054",
            "name": "シャンボール",
            "price": 700
          },
          {
            "id": "M055",
            "name": "フランジェリコ",
            "price": 700
          },
          {
            "id": "M056",
            "name": "パッソア",
            "price": 700
          },
          {
            "id": "M057",
            "name": "カルーア",
            "price": 700
          },
          {
            "id": "M058",
            "name": "ティフィン",
            "price": 700
          },
          {
            "id": "M059",
            "name": "ディタ",
            "price": 700
          }
        ]
      }
    ]
  },
  {
    "id": "C03",
    "name": "Liqueur Base",
    "subCategories": [
      {
        "id": "S00",
        "name": "-",
        "items": [
          {
            "id": "M060",
            "name": "アマレットジンジャー",
            "price": 750
          },
          {
            "id": "M061",
            "name": "レゲエパンチ",
            "price": 700
          },
          {
            "id": "M062",
            "name": "マリブコーク",
            "price": 750
          },
          {
            "id": "M063",
            "name": "パッソアオレンジ",
            "price": 750
          },
          {
            "id": "M064",
            "name": "ティフィンミルク",
            "price": 750
          },
          {
            "id": "M065",
            "name": "ベイリーズミルク",
            "price": 750
          },
          {
            "id": "M066",
            "name": "抹茶ミルク",
            "price": 750
          },
          {
            "id": "M067",
            "name": "照葉樹林",
            "price": 750
          },
          {
            "id": "M068",
            "name": "ベルモットカシス",
            "price": 750
          },
          {
            "id": "M069",
            "name": "シャンボールミルク",
            "price": 750
          },
          {
            "id": "M070",
            "name": "フランジェリコミルク",
            "price": 750
          },
          {
            "id": "M071",
            "name": "ダージリンクーラー",
            "price": 800
          },
          {
            "id": "M072",
            "name": "イエーガークーク",
            "price": 850
          },
          {
            "id": "M073",
            "name": "ロングアイランドアイスティー",
            "price": 950
          }
        ]
      }
    ]
  },
  {
    "id": "C04",
    "name": "SOUR & SHOCHU",
    "subCategories": [
      {
        "id": "S14",
        "name": "中ジョッキ (700yen)",
        "items": [
          {
            "id": "M074",
            "name": "緑茶",
            "price": 700
          },
          {
            "id": "M075",
            "name": "ウーロン茶",
            "price": 700
          },
          {
            "id": "M076",
            "name": "ジャスミン茶",
            "price": 700
          },
          {
            "id": "M077",
            "name": "レモン",
            "price": 700
          }
        ]
      },
      {
        "id": "S15",
        "name": "大ジョッキ (1100yen)",
        "items": [
          {
            "id": "M078",
            "name": "緑茶",
            "price": 1100
          },
          {
            "id": "M079",
            "name": "ウーロン茶",
            "price": 1100
          },
          {
            "id": "M080",
            "name": "ジャスミン茶",
            "price": 1100
          },
          {
            "id": "M081",
            "name": "レモン",
            "price": 1100
          }
        ]
      },
      {
        "id": "S16",
        "name": "特大ジョッキ (1650yen)",
        "items": [
          {
            "id": "M082",
            "name": "緑茶",
            "price": 1650
          },
          {
            "id": "M083",
            "name": "ウーロン茶",
            "price": 1650
          },
          {
            "id": "M084",
            "name": "ジャスミン茶",
            "price": 1650
          },
          {
            "id": "M085",
            "name": "レモン",
            "price": 1650
          }
        ]
      },
      {
        "id": "S17",
        "name": "中ジョッキ (750yen)",
        "items": [
          {
            "id": "M086",
            "name": "紅茶",
            "price": 750
          },
          {
            "id": "M087",
            "name": "ピゲ茶",
            "price": 750
          },
          {
            "id": "M088",
            "name": "カルピス",
            "price": 750
          },
          {
            "id": "M089",
            "name": "ライム",
            "price": 750
          },
          {
            "id": "M090",
            "name": "トマト",
            "price": 750
          },
          {
            "id": "M091",
            "name": "グレープフルーツ",
            "price": 750
          },
          {
            "id": "M092",
            "name": "パイン",
            "price": 750
          },
          {
            "id": "M093",
            "name": "クランベリー",
            "price": 750
          },
          {
            "id": "M094",
            "name": "オレンジ",
            "price": 750
          },
          {
            "id": "M095",
            "name": "カフェ耐",
            "price": 750
          }
        ]
      },
      {
        "id": "S18",
        "name": "大ジョッキ (1150yen)",
        "items": [
          {
            "id": "M096",
            "name": "紅茶/ピゲ茶/カルピス/ライム/トマト/グレープフルーツ/パイン/クランベリー/オレンジ/カフェ耐",
            "price": 1150
          }
        ]
      }
    ]
  },
  {
    "id": "C05",
    "name": "Shot",
    "subCategories": [
      {
        "id": "S00",
        "name": "-",
        "items": [
          {
            "id": "M097",
            "name": "コカレロ",
            "price": 800
          },
          {
            "id": "M098",
            "name": "コカボム",
            "price": 1000
          },
          {
            "id": "M099",
            "name": "イエーガー",
            "price": 700
          },
          {
            "id": "M100",
            "name": "クエルボ",
            "price": 600
          }
        ]
      }
    ]
  },
  {
    "id": "C06",
    "name": "Wine",
    "subCategories": [
      {
        "id": "S19",
        "name": "グラスワイン",
        "items": [
          {
            "id": "M101",
            "name": "赤",
            "price": 700
          },
          {
            "id": "M102",
            "name": "白",
            "price": 700
          }
        ]
      },
      {
        "id": "S20",
        "name": "Wine Cocktail",
        "items": [
          {
            "id": "M103",
            "name": "ワインクーラー",
            "price": 750
          },
          {
            "id": "M104",
            "name": "アメリカンレモネード",
            "price": 750
          },
          {
            "id": "M105",
            "name": "キティ",
            "price": 750
          },
          {
            "id": "M106",
            "name": "スプリッツァー",
            "price": 750
          },
          {
            "id": "M107",
            "name": "オペレーター",
            "price": 750
          },
          {
            "id": "M108",
            "name": "キール",
            "price": 750
          }
        ]
      }
    ]
  },
  {
    "id": "C07",
    "name": "Shochu & Plum Wine",
    "subCategories": [
      {
        "id": "S21",
        "name": "芋",
        "items": [
          {
            "id": "M109",
            "name": "黒霧島",
            "price": 700
          },
          {
            "id": "M110",
            "name": "富乃宝山",
            "price": 750
          }
        ]
      },
      {
        "id": "S22",
        "name": "米",
        "items": [
          {
            "id": "M111",
            "name": "しろ",
            "price": 650
          }
        ]
      },
      {
        "id": "S23",
        "name": "紫蘇",
        "items": [
          {
            "id": "M112",
            "name": "鍛高譚",
            "price": 700
          }
        ]
      },
      {
        "id": "S24",
        "name": "梅酒",
        "items": [
          {
            "id": "M113",
            "name": "梅酒 (ロック)",
            "price": 700
          }
        ]
      },
      {
        "id": "S00",
        "name": "-",
        "items": [
          {
            "id": "M114",
            "name": "ソーダ、湯、割り物etc...",
            "price": 50
          }
        ]
      }
    ]
  },
  {
    "id": "C08",
    "name": "Beer",
    "subCategories": [
      {
        "id": "S25",
        "name": "一番搾り",
        "items": [
          {
            "id": "M115",
            "name": "キリン一番搾り 生ビール (グラス)",
            "price": 750
          },
          {
            "id": "M116",
            "name": "キリン一番搾り 生ビール (大)",
            "price": 1200
          },
          {
            "id": "M117",
            "name": "キリン一番搾り 生ビール (特大)",
            "price": 1700
          }
        ]
      },
      {
        "id": "S26",
        "name": "Bottle",
        "items": [
          {
            "id": "M118",
            "name": "ハイネケン",
            "price": 800
          },
          {
            "id": "M119",
            "name": "コロナ",
            "price": 800
          },
          {
            "id": "M120",
            "name": "スカイブルー",
            "price": 750
          },
          {
            "id": "M121",
            "name": "スミノフアイス",
            "price": 750
          },
          {
            "id": "M122",
            "name": "ギネス",
            "price": 750
          }
        ]
      },
      {
        "id": "S27",
        "name": "BEER BASE (ALL 800yen)",
        "items": [
          {
            "id": "M123",
            "name": "レッドアイ",
            "price": 800
          },
          {
            "id": "M124",
            "name": "カンパビール",
            "price": 800
          },
          {
            "id": "M125",
            "name": "シャンディガフ",
            "price": 800
          },
          {
            "id": "M126",
            "name": "クランベリービア",
            "price": 800
          }
        ]
      }
    ]
  },
  {
    "id": "C09",
    "name": "Whisky",
    "subCategories": [
      {
        "id": "S28",
        "name": "Bourbon",
        "items": [
          {
            "id": "M127",
            "name": "ジムビーム",
            "price": 700
          },
          {
            "id": "M128",
            "name": "サントリーオールド",
            "price": 750
          },
          {
            "id": "M129",
            "name": "I.W.ハーパー",
            "price": 750
          },
          {
            "id": "M130",
            "name": "ジャック・ダニエル",
            "price": 750
          },
          {
            "id": "M131",
            "name": "ワイルドターキー 8年",
            "price": 900
          },
          {
            "id": "M132",
            "name": "メーカーズマーク レッドトップ",
            "price": 850
          }
        ]
      },
      {
        "id": "S29",
        "name": "Irish",
        "items": [
          {
            "id": "M133",
            "name": "ブッシュミルズ",
            "price": 700
          },
          {
            "id": "M134",
            "name": "ジェイムソン",
            "price": 700
          }
        ]
      },
      {
        "id": "S30",
        "name": "Canadian",
        "items": [
          {
            "id": "M135",
            "name": "カナディアンクラブ",
            "price": 750
          }
        ]
      },
      {
        "id": "S31",
        "name": "Scotch",
        "items": [
          {
            "id": "M136",
            "name": "バランタイン 12年",
            "price": 750
          },
          {
            "id": "M137",
            "name": "シーバスリーガル 12年",
            "price": 800
          },
          {
            "id": "M138",
            "name": "ボウモア 12年",
            "price": 1050
          },
          {
            "id": "M139",
            "name": "ラフロイグ 10年",
            "price": 1100
          },
          {
            "id": "M140",
            "name": "グレンリベット 12年",
            "price": 950
          }
        ]
      },
      {
        "id": "S00",
        "name": "-",
        "items": [
          {
            "id": "M141",
            "name": "ソーダ割り、その他割り物",
            "price": 50
          }
        ]
      }
    ]
  },
  {
    "id": "C10",
    "name": "Highball",
    "subCategories": [
      {
        "id": "S00",
        "name": "-",
        "items": [
          {
            "id": "M142",
            "name": "HERO'S ハイボール",
            "price": 700
          },
          {
            "id": "M195",
            "name": "HERO'S ハイボール (大)",
            "price": 1100
          }
        ]
      }
    ]
  },
  {
    "id": "C11",
    "name": "Soft Drink",
    "subCategories": [
      {
        "id": "S32",
        "name": "各500yen",
        "items": [
          {
            "id": "M143",
            "name": "ヒゲ茶",
            "price": 500
          },
          {
            "id": "M144",
            "name": "緑茶",
            "price": 500
          },
          {
            "id": "M145",
            "name": "アイスティー",
            "price": 500
          },
          {
            "id": "M146",
            "name": "ジャスミン茶",
            "price": 500
          },
          {
            "id": "M147",
            "name": "ウーロン茶",
            "price": 500
          },
          {
            "id": "M148",
            "name": "ゆず茶",
            "price": 500
          },
          {
            "id": "M149",
            "name": "〈HOT〉ホットティー",
            "price": 500
          },
          {
            "id": "M150",
            "name": "〈HOT〉ホットコーヒー",
            "price": 500
          },
          {
            "id": "M151",
            "name": "〈HOT〉ジャスミン茶",
            "price": 500
          },
          {
            "id": "M152",
            "name": "〈HOT〉ウーロン茶",
            "price": 500
          },
          {
            "id": "M153",
            "name": "〈HOT〉ユズ茶",
            "price": 500
          },
          {
            "id": "M154",
            "name": "〈HOT〉緑茶",
            "price": 500
          },
          {
            "id": "M169",
            "name": "ヒゲ茶 (大)",
            "price": 900
          },
          {
            "id": "M170",
            "name": "緑茶 (大)",
            "price": 900
          },
          {
            "id": "M171",
            "name": "アイスティー (大)",
            "price": 900
          },
          {
            "id": "M172",
            "name": "ジャスミン茶 (大)",
            "price": 900
          },
          {
            "id": "M173",
            "name": "ウーロン茶 (大)",
            "price": 900
          },
          {
            "id": "M174",
            "name": "ゆず茶 (大)",
            "price": 900
          },
          {
            "id": "M175",
            "name": "〈HOT〉ホットティー (大)",
            "price": 900
          },
          {
            "id": "M176",
            "name": "〈HOT〉ホットコーヒー (大)",
            "price": 900
          },
          {
            "id": "M177",
            "name": "〈HOT〉ジャスミン茶 (大)",
            "price": 900
          },
          {
            "id": "M178",
            "name": "〈HOT〉ウーロン茶 (大)",
            "price": 900
          },
          {
            "id": "M179",
            "name": "〈HOT〉ユズ茶 (大)",
            "price": 900
          },
          {
            "id": "M180",
            "name": "〈HOT〉緑茶 (大)",
            "price": 900
          }
        ]
      },
      {
        "id": "S33",
        "name": "各550yen",
        "items": [
          {
            "id": "M155",
            "name": "オレンジ",
            "price": 550
          },
          {
            "id": "M156",
            "name": "グレープフルーツ",
            "price": 550
          },
          {
            "id": "M157",
            "name": "パイン",
            "price": 550
          },
          {
            "id": "M158",
            "name": "クランベリー",
            "price": 550
          },
          {
            "id": "M159",
            "name": "トマト",
            "price": 550
          },
          {
            "id": "M160",
            "name": "アイスコーヒー",
            "price": 550
          },
          {
            "id": "M161",
            "name": "カフェオレ",
            "price": 550
          },
          {
            "id": "M162",
            "name": "ジンジャエール (甘口・辛口)",
            "price": 550
          },
          {
            "id": "M181",
            "name": "オレンジ (大)",
            "price": 1000
          },
          {
            "id": "M182",
            "name": "グレープフルーツ (大)",
            "price": 1000
          },
          {
            "id": "M183",
            "name": "パイン (大)",
            "price": 1000
          },
          {
            "id": "M184",
            "name": "クランベリー (大)",
            "price": 1000
          },
          {
            "id": "M185",
            "name": "トマト (大)",
            "price": 1000
          },
          {
            "id": "M186",
            "name": "アイスコーヒー (大)",
            "price": 1000
          },
          {
            "id": "M187",
            "name": "カフェオレ (大)",
            "price": 1000
          },
          {
            "id": "M188",
            "name": "ジンジャエール (甘口・辛口) (大)",
            "price": 1000
          }
        ]
      },
      {
        "id": "S34",
        "name": "各600yen",
        "items": [
          {
            "id": "M163",
            "name": "シャーリーテンプル",
            "price": 600
          },
          {
            "id": "M164",
            "name": "サラトガクーラー",
            "price": 600
          },
          {
            "id": "M165",
            "name": "シンデレラ",
            "price": 600
          },
          {
            "id": "M166",
            "name": "RedBull",
            "price": 600
          },
          {
            "id": "M167",
            "name": "カルピスミルク",
            "price": 600
          },
          {
            "id": "M168",
            "name": "コーラ",
            "price": 600
          },
          {
            "id": "M189",
            "name": "シャーリーテンプル (大)",
            "price": 1100
          },
          {
            "id": "M190",
            "name": "サラトガクーラー (大)",
            "price": 1100
          },
          {
            "id": "M191",
            "name": "シンデレラ (大)",
            "price": 1100
          },
          {
            "id": "M192",
            "name": "RedBull (大)",
            "price": 1100
          },
          {
            "id": "M193",
            "name": "カルピスミルク (大)",
            "price": 1100
          },
          {
            "id": "M194",
            "name": "コーラ (大)",
            "price": 1100
          }
        ]
      }
    ]
  }
];
